<template>
  <div class="col-sm-12">
    <div class="card">
      <div class="table-responsive">
        <table class="table">
          <thead>
            <tr>
              <th scope="col" class="text-center">Nro</th>
              <th scope="col" class="text-start">Nombre del Formulario</th>
              <th scope="col" class="text-start">Descripción</th>
              <th scope="col" class="text-start">Tipo</th>
              <th scope="col" class="text-center">Creado por</th>
              <th scope="col" class="text-center">Vista Previa</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loading">
              <td colspan="7" class="text-center py-4">
                <div class="spinner-border text-primary" role="status">
                  <span class="visually-hidden">Cargando...</span>
                </div>
              </td>
            </tr>
            <tr v-else-if="paginatedItems.length === 0">
              <td colspan="7" class="text-center py-4 text-muted">
                <EmptyState title="No se encontraron formularios." :size="450" fontSize="fs-5" /> 
              </td>
            </tr>
            <tr v-else v-for="(item, index) in paginatedItems" :key="item.id">
              <th scope="row" class="text-center">
                {{ (currentPage - 1) * itemsPerPage + index + 1 }}
              </th>
              <td>{{ item.detail }}</td>
              <td>{{ item.description }}</td>
              <td>{{ item.type }}</td>
              <td class="text-center">{{ item.user }} <br> {{ item.rol }}</td>
              <td class="text-center">
                <ModalDinamicPreview 
                  :fields="parseFields(item.html)" 
                  :modalId="`modal-preview-${item.id}`" 
                  :showButton="true" 
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <Pagination 
        :totalItems="items.length" 
        :itemsPerPage="itemsPerPage" 
        @page-change="handlePageChange" 
      />
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from "vue";
import Pagination from "@/pages/components/Pagination.vue";
import ModalDinamicPreview from "./ModalDinamicPreview.vue";
import EmptyState from '@/components/emptyState.vue'

const props = defineProps({
  items: {
    type: Array,
    default: () => []
  },
  loading: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['stateChanged']);

const currentPage = ref(1);
const itemsPerPage = ref(10);
const userId = localStorage.getItem("userId");

const paginatedItems = computed(() => {
  const startIndex = (currentPage.value - 1) * itemsPerPage.value;
  const endIndex = startIndex + itemsPerPage.value;
  return props.items.slice(startIndex, endIndex);
});

function parseFields(html) {
  if (!html) return [];
  try {
    return JSON.parse(html);
  } catch {
    return [];
  }
}

function canEditState(item) {
  return item.user_id === userId;
}

function handleStateChange(formId) {
  emit('stateChanged', formId);
}

function handlePageChange(page) {
  currentPage.value = page;
}

watch(() => props.items, () => {
  currentPage.value = 1;
}, { deep: true });
</script>